import React from 'react';
import ScoreEntryView from '../components/admin/ScoreEntryView';

const ScoreEntryViewWrapper = ({
  currentClubs,
  clubs,
  APPARATUS_OPTIONS,
  LEVEL_OPTIONS,
  FRANJA_OPTIONS,
  updateScore
}) => {
  return (
    <ScoreEntryView
      currentClubs={currentClubs}
      clubs={clubs}
      updateScore={updateScore}
      APPARATUS_OPTIONS={APPARATUS_OPTIONS}
      LEVEL_OPTIONS={LEVEL_OPTIONS}
      FRANJA_OPTIONS={FRANJA_OPTIONS}
    />
  );
};

export default ScoreEntryViewWrapper;